"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasValue; // Determines if the given toggle group value is present.

function hasValue(value) {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return !!value;
}